/* eslint-disable no-shadow */
import Vue from 'vue';

const state = {
  name: 'Auth',
  userSession: null,
  userEmail: 'null',
  isLoggedIn: false,
  userGroups: [],
  userCustomer: '',
  userRole: '',
};

const getters = {
  userAccessToken: (state) => {
    const doesUserSessionExist = !!state.userSession;
    if (!doesUserSessionExist) return null;
    return state.userSession.accessToken;
  },

  idTokenPayload: (state, getters) => {
    const doesPayloadExist = !!getters.userIdToken && !!getters.userIdToken.payload;
    if (!doesPayloadExist) return null;
    return getters.userIdToken.payload;
  },

  userIdToken: (state) => {
    const doesUserSessionExist = !!state.userSession;
    if (!doesUserSessionExist) return {};
    return state.userSession.idToken;
  },

  userEmail: (state, getters) => {
    const hasPayload = !!getters.idTokenPayload;
    return hasPayload ? getters.idTokenPayload.email : '';
  },
};

const mutations = {
  setSession: (state, payload) => {
    Vue.set(state, 'userSession', payload);
    const doesIdTokenPayloadExist = !!payload.idToken && !!payload.idToken.payload;
    Vue.set(state, 'isLoggedIn', true);
    if (!doesIdTokenPayloadExist) return;
    Vue.set(state, 'userEmail', payload.idToken.payload.email);
  },

  setIsLoggedIn: (state, payload) => {
    Vue.set(state, 'isLoggedIn', payload);
  },
};

const actions = {
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
